import React from 'react';

import { Card, Grid, Typography } from '@mui/material';

import { blackText } from '../../constants/Colors';

const styles = {
  article: {
    margin: '20px 0'
  },
  body: {
    marginLeft: '1em'
  },
  card: {
    '@media screen and (max-width:480px)': {
      padding: '16px'
    },
    '@media screen and (max-width:960px)': {
      marginLeft: '16px',
      marginRight: '16px',
      padding: '20px'
    },
    boxShadow: 0,
    margin: '24px 80px',
    maxWidth: '1280px',
    padding: '40px'
  },
  ordered: {
    marginLeft: '2em',
    overflowWrap: 'break-word',
    textIndent: '-1.5em'
  },
  orderedText: {
    flex: 1,
    overflowWrap: 'break-word'
  },
  pageTitle: {
    color: blackText,
    fontSize: '22px',
    marginBottom: '24px'
  },
  text: {
    color: blackText,
    fontSize: '14px',
    marginBottom: '5px',
    whiteSpace: 'pre-line'
  },
  textMargin: {
    marginBottom: '15px'
  }
};

export interface StaticTextType {
  pageTitle: string;
  description?: string;
  body: Array<{
    type: string;
    title: string;
    text?: string;
    ordered?: Array<{
      text: string;
      ordered?: Array<{
        text: string;
      }>;
    }>;
  }>;
  bottomText: string;
  bottomText2?: string;
}

interface Props {
  content: StaticTextType;
}

const StaticTextCard: React.FC<Props> = (props: Props) => {
  const { content } = props;

  return (
    <>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid>
          <Card sx={styles.card}>
            <Grid>
              <Typography component="div" sx={styles.pageTitle}>
                {content.pageTitle}
              </Typography>
              {content.description && (
                <Typography
                  component="div"
                  sx={[styles.text, styles.textMargin]}
                >
                  {content.description}
                </Typography>
              )}
              {content.body.map((elem, elemIndex) => {
                if (elem.type === 'textOnly') {
                  return (
                    <Typography
                      component="div"
                      sx={styles.article}
                      key={elemIndex}
                    >
                      <Typography component="div" sx={styles.text}>
                        {elem.title}
                      </Typography>
                      <Typography
                        component="div"
                        sx={[styles.body, styles.text]}
                      >
                        {elem.text}
                      </Typography>
                    </Typography>
                  );
                } else if (elem.type === 'ordered') {
                  return (
                    <Typography
                      component="div"
                      sx={styles.article}
                      key={elemIndex}
                    >
                      <Typography component="div" sx={styles.text}>
                        {elem.title}
                      </Typography>
                      <Typography
                        component="div"
                        sx={[styles.text, styles.body]}
                      >
                        {elem.ordered?.map((ordered, orderedIndex) => (
                          <Typography component="div" key={orderedIndex}>
                            <Grid container flexDirection="row">
                              <Typography
                                component="p"
                                sx={[styles.text, styles.ordered]}
                              >
                                {`${orderedIndex + 1}.  `}
                              </Typography>
                              <Typography
                                component="p"
                                sx={[styles.text, styles.orderedText]}
                              >
                                {ordered.text}
                              </Typography>
                            </Grid>
                            {ordered.ordered && (
                              <Typography component="div" sx={styles.body}>
                                {ordered.ordered.map(
                                  (parentheses, parenthesesIndex) => (
                                    <Grid
                                      container
                                      flexDirection="row"
                                      key={parenthesesIndex}
                                    >
                                      <Typography
                                        component="div"
                                        sx={[styles.text, styles.ordered]}
                                      >
                                        {`（${parenthesesIndex + 1}）`}
                                      </Typography>
                                      <Typography
                                        component="p"
                                        sx={[styles.text, styles.orderedText]}
                                      >
                                        {parentheses.text}
                                      </Typography>
                                    </Grid>
                                  )
                                )}
                              </Typography>
                            )}
                          </Typography>
                        ))}
                      </Typography>
                    </Typography>
                  );
                } else if (elem.type === 'textAndOrderd') {
                  return (
                    <Typography
                      component="div"
                      sx={styles.article}
                      key={elemIndex}
                    >
                      <Typography component="div" sx={styles.text}>
                        {elem.title}
                      </Typography>
                      <Typography
                        component="div"
                        sx={[styles.text, styles.body]}
                      >
                        {elem.text}
                      </Typography>
                      <Typography
                        component="div"
                        sx={[styles.text, styles.body]}
                      >
                        {elem.ordered?.map((ordered, orderedIndex) => (
                          <Grid
                            container
                            flexDirection="row"
                            key={orderedIndex}
                          >
                            <Typography
                              component="div"
                              sx={[styles.text, styles.ordered]}
                            >
                              {`（${orderedIndex + 1}）`}
                            </Typography>
                            <Typography
                              component="div"
                              sx={[styles.text, styles.orderedText]}
                            >
                              {ordered.text}
                            </Typography>
                          </Grid>
                        ))}
                      </Typography>
                    </Typography>
                  );
                }
                return null;
              })}
              <Typography component="div" sx={styles.text}>
                {content.bottomText}
              </Typography>
              <Typography component="div" sx={[styles.text, styles.textMargin]}>
                {content.bottomText2}
              </Typography>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      <Typography></Typography>
    </>
  );
};

export default StaticTextCard;
